(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.componentPropTypes = exports.oneOfProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(11);

var oneOfProps = exports.oneOfProps = {
  colour: ['green-light', 'green', 'green-medium', 'green-dark', 'yellow', 'yellow-dark', 'pink', 'pink-dark', 'red', 'red-dark', 'purple', 'purple-medium', 'purple-dark', 'orange', 'orange-medium', 'orange-dark', 'blue', 'blue-medium', 'blue-dark', 'white', 'almost-light', 'grey-light', 'grey', 'grey-medium', 'grey-dark', 'almost-black'],
  textSize: ['small']
};

var componentPropTypes = exports.componentPropTypes = {
  colour: _propTypes2.default.oneOf(oneOfProps.colour).isRequired,
  raised: _propTypes2.default.bool,
  outlined: _propTypes2.default.bool,
  unstyled: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  textSize: _propTypes2.default.oneOf(oneOfProps.textSize),
  fullWidth: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.any.isRequired
};

var defaultProps = exports.defaultProps = {
  colour: 'grey-medium',
  raised: false
};

var setClassName = function setClassName(props) {
  return (0, _classnames2.default)('button', { 'button--disabled': props.disabled }, { 'button--unstyled': props.unstyled }, _defineProperty({}, 'button--' + props.colour, props.colour && props.colour !== 'default' && !props.unstyled && !props.disabled), {
    'button--raised': props.raised && !props.unstyled && !props.disabled
  }, { 'button--outlined': props.outlined && !props.unstyled }, _defineProperty({}, 'button--' + props.textSize, props.textSize), { 'button--full-width': props.fullWidth }, props.className);
};

var addClassNameToProps = function addClassNameToProps(props) {
  return _extends({}, props, {
    className: setClassName(props)
  });
};

var Button = function Button(props) {
  var withOmitted = (0, _omit2.default)(['colour', 'raised', 'outlined', 'unstyled', 'textSize', 'fullWidth'])(addClassNameToProps(props));
  return props.href ? _react2.default.createElement(
    'a',
    withOmitted,
    props.children
  ) : _react2.default.createElement(
    'button',
    withOmitted,
    props.children
  );
};

Button.propTypes = componentPropTypes;
Button.defaultProps = defaultProps;

exports.default = Button;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/fp/omit");

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(10);


/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/Button.js
// module id = 13
// module chunks = 0